import ArticleLayout from '@/components/feature/ArticleLayout';
import { sugargooWarehouse } from '@/utils/articleContent';

export default function SugargooWarehousePage() {
  return <ArticleLayout article={sugargooWarehouse} />;
}